import { AxiosRequestConfig, AxiosResponse } from 'axios';
import createHttp from '@/utils/axiosHttp';
import { isResponse } from '@/types';
import NProgress from 'nprogress';
import Cookie from 'js-cookie';
type selfRes = {
  code?: number,
  msg?: string,
  data?: any
}

const http = createHttp({
  timeout: 20000,
  baseURL: 'api',
  withCredentials: true,
  xsrfCookieName: 'Authorization',
  xsrfHeaderName: 'Authorization',
  headers:{
    common:{
      "Authorization": "Bearer "+Cookie.get('Authorization')
    }
  }
});

// declare module "axios" {
//   interface AxiosResponse<T = any> {
//     error: number;
//     msg: string;
//     code:number | string;
//     // 这里追加你的参数
//   }
//   export function create(config?: AxiosRequestConfig): AxiosInstance;
// }

const isAxiosResponse = (obj: any): obj is AxiosResponse => {
  return typeof obj === 'object' && obj.status && obj.statusText && obj.headers && obj.config;
};

// progress 进度条 -- 开启
http.interceptors.request.use((req: AxiosRequestConfig) => {
  if (!NProgress.isStarted()) {
    NProgress.start();
  }
  req.headers['Authorization'] = 'Bearer ' + Cookie.get('Authorization');
  return req;
});

// 解析响应结果
http.interceptors.response.use(
  (rep: AxiosResponse<any>) => {
    const { data,headers} = rep;
    if (isResponse(data)) {
      if(data.code == 0){
        return data;
      }
      if(headers['dataType'] === 'blob'){
        return Promise.reject(data);
      }else{
        return Promise.reject(data.data);
      }
    }else{
      if(headers['dataType'] === 'blob'){
        return Promise.reject({ message: rep.statusText, code: rep.status, data });
      }else{
        return Promise.reject({ message: rep.statusText, code: rep.status,data: data.data });
      }
     
    }
    
  },
  (error) => {
    if (error.response && isAxiosResponse(error.response)) {
      return Promise.reject({
        message: error.response.statusText,
        code: error.response.status,
        data: error.response.data,
      });
    }
    return Promise.reject(error);
  }
);

// progress 进度条 -- 关闭
http.interceptors.response.use(
  (rep) => {
    if (NProgress.isStarted()) {
      NProgress.done();
    }
    return rep;
  },
  (error) => {
    if (NProgress.isStarted()) {
      NProgress.done();
    }
    return error;
  }
);

export default http;
